import React from 'react';

import { truncateText } from '../../utils/utilFunctions';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import Image from 'next/image';

import Link from 'next/link';
function MostVisitedPost(props) {
 return (
  <div className=' xg-blue-900 w-full flex items-start justify-start flex-col gap-3'>
   <p className='text-backbg/80  font-bold text-xl '> Posts Les Plus Vues</p>

   {props.mostViewArticles.mostViewArticles_data && props.mostViewArticles.mostViewArticles_data.length != 0 ? (
    <Link
     href={{
      pathname: `${process.env.NEXT_PUBLIC_origin}/articles/${props.mostViewArticles.mostViewArticles_data[0].articleUrl}`,
     }}
     className='flex items-start justify-center flex-col gap-2 buttonsStyle'
    >
     <div className='flex items-center justify-center flex-col w-full h-[200px] bg-gray-500  mt-2'>
      <Image width={500} height={500} alt={props.mostViewArticles.mostViewArticles_data[0].articleUrl} src={props.mostViewArticles.mostViewArticles_data[0].images} className='     object-cover h-full    ' />
     </div>
     <p className='text-backbg/50 text-xs capitalize'>
      {format(new Date(props.mostViewArticles.mostViewArticles_data[0].updatedAt), 'MMM d, yyyy', {
       locale: fr,
      })}{' '}
     </p>
     <p className='text-backbg/80 text-sm capitalize'>{truncateText(props.mostViewArticles.mostViewArticles_data[0].title, 60)}</p>
    </Link>
   ) : (
    ''
   )}

   {props.err == '' && props.mostViewArticles.mostViewArticles_data && props.mostViewArticles.mostViewArticles_data.length != 0
    ? props.mostViewArticles.mostViewArticles_data.map((element, index) => {
       if (index != 0)
        return (
         <Link
          key={element.title}
          href={{
           pathname: `${process.env.NEXT_PUBLIC_origin}/articles/${element.articleUrl}`,
          }}
          className=' flex flex-col gap-2'
         >
          <span className='w-full h-[1px]  border  border-black/5'></span>
          <div className='flex items-start justify-center flex-row gap-2 g-orange-500 buttonsStyle'>
           <div className='flex items-center justify-center flex-col max-w-[100px]  h-[75px] bg-gray-500'>
            <Image width={500} height={500} alt={element.articleUrl} src={element.images} className='    object-cover h-full    ' />
           </div>
           <div className='flex flex-col justify-center items-start gap-2'>
            <p className='text-backbg/50 text-xs capitalize'>
             {format(new Date(element.updatedAt), 'MMM d, yyyy', {
              locale: fr,
             })}{' '}
            </p>
            <p className='text-backbg/80 text-xs '>{truncateText(element.title, 60)}</p>
           </div>
          </div>
         </Link>
        );
      })
    : ''}
  </div>
 );
}

export default MostVisitedPost;
